<template>
  <footer class="footer">
    <FooterMenuTeam />

    <div class="footer__container">
      <Wrapper>
        <div class="footer__content">
          <div class="footer__copyright">
            <p class="footer__copyright-text">
              &copy;{{ new Date().getFullYear() }} UFL Enterprises LLC. All Rights Reserved.
            </p>
          </div>

          <FooterMenu />

          <div class="footer__powered-by">
            <WMTLogo class="footer__wmt" />
          </div>
        </div>
      </Wrapper>
    </div>
  </footer>
</template>

<style scoped lang="scss">
  .footer {
    @apply bg-primary relative z-[1];

    &__container {
      @apply border-t border-t-white/10 py-[40px];
      @apply xl:py-[60px];
    }

    &__content {
      @apply flex items-center justify-between flex-col w-full gap-[30px];
      @apply md:gap-[20px];
      @apply xl:flex-row xl:gap-0;
    }

    &__copyright {
      @apply text-center;
      @apply xl:text-left xl:mr-[60px];
      @apply xl:mr-[150px];

      &-text {
        @apply text-[14px] text-white/60;
      }
    }

    &__powered-by {
      @apply xl:ml-[40px];
    }

    &__wmt {
      @apply inline-flex items-center;

      span {
        @apply text-[14px] text-white/60 mr-[10px];
      }

      img {
        @apply w-[70px] h-auto block;
      }
    }
  }
</style>
